import styled from 'styled-components';
import { colorBlack900, colorBlack200, colorGrey50, fontFamilyRaleway, fontFamilyRoboto, mediaQueryMobileLargeMin, colorGreen400 } from 'styleUtils';
export var MoreInfoWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x36yx5-0"
})(["display:", ";width:100%;"], function (_ref) {
  var isShowMoreInfo = _ref.isShowMoreInfo;
  return isShowMoreInfo ? 'block' : 'none';
});
export var MoreInfoTitle = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-1x36yx5-1"
})(["width:100%;margin:16px 0;font-family:", ";font-weight:bold;font-size:14px;line-height:18px;cursor:default;color:", ";"], fontFamilyRaleway, colorBlack900);
export var MoreInfoBlock = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x36yx5-2"
})(["display:flex;flex-direction:column;width:100%;"]);
export var MoreInfoItem = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x36yx5-3"
})(["display:flex;flex-direction:row;width:100%;border-top:1px solid ", ";padding:16px 0;"], colorGrey50);
export var MoreInfoItemTitle = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x36yx5-4"
})(["width:40%;font-family:", ";font-size:12px;line-height:18px;word-break:break-word;cursor:default;color:", ";@media ", "{font-size:14px;line-height:24px;}"], fontFamilyRoboto, colorBlack200, mediaQueryMobileLargeMin);
export var MoreInfoItemContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x36yx5-5"
})(["width:60%;font-family:", ";font-size:12px;line-height:18px;padding:0 0 0 10px;text-align:end;cursor:default;color:", ";& a,a:visited{color:", ";}@media ", "{text-align:start;font-size:14px;line-height:24px;}"], fontFamilyRoboto, colorBlack900, colorGreen400, mediaQueryMobileLargeMin);
export var MoreInfoItemContentList = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-1x36yx5-6"
})([""]);
export var MoreInfoItemContentItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1x36yx5-7"
})(["list-style-type:disc;list-style-position:inside;"]);